import { jsx as _jsx } from "react/jsx-runtime";
export const Width = ({ width, children }) => {
    const widthNumber = typeof width === 'string' ? parseFloat(width.replace('%', '')) : width;
    return (_jsx("div", { style: {
            flex: `0 0 calc(${widthNumber}% - 20px)`,
            flexGrow: 1,
        }, children: children }));
};
